// AutoGenerated
export class HesapDuyuruModel {
    hesapModelId!: string;
    duyuruModelId!: string;
    okundu!: boolean | null;
}